// Zustand store for authentication
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, AuthResponse } from '@mymap/shared/user';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  expiresAt: number | null;
  setAuth: (data: AuthResponse) => void;
  setUser: (user: User) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      expiresAt: null,
      setAuth: (data) => {
        set({
          user: data.user,
          accessToken: data.accessToken,
          expiresAt: Date.now() + data.expiresIn * 1000,
        });
      },
      setUser: (user) => set({ user }),
      logout: () => set({ user: null, accessToken: null, expiresAt: null }),
      isAuthenticated: () => {
        const { accessToken, expiresAt } = get();
        return !!accessToken && !!expiresAt && Date.now() < expiresAt;
      },
    }),
    { name: 'mymap-auth' }
  )
);
